// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {connect} from 'react-redux';
import {bindActionCreators, type Dispatch} from 'redux';

import {type GenericAction} from 'mattermost-redux/types/actions';
import {appsEnabled} from 'mattermost-redux/selectors/entities/apps';

import {toggleEmbedVisibility} from 'actions/post_actions';
import {isEmbedVisible} from 'selectors/posts';
import {type GlobalState} from 'types/store';
import {type PostWillRenderEmbedPluginComponent} from 'types/store/plugins';
import {getPost} from 'mattermost-redux/selectors/entities/posts';

import {getFirstQuoteEmbedFromMetadata} from 'mattermost-redux/utils/post_utils';

import PostBodyAdditionalContent, {
    type Props,
} from './post_body_additional_content';

function mapStateToProps(state: GlobalState, ownProps: Props) {
    const quoteMetadata = getFirstQuoteEmbedFromMetadata(ownProps.post.metadata);
    const quote = quoteMetadata && quoteMetadata.data?.post_id ? getPost(state, quoteMetadata.data?.post_id) : undefined;
    return {
        quote,
        quoteMetadata,
        isEmbedVisible: isEmbedVisible(state, ownProps.post.id),
        pluginPostWillRenderEmbedComponents: state.plugins.components.PostWillRenderEmbedComponent as unknown as PostWillRenderEmbedPluginComponent[],
        appsEnabled: appsEnabled(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators({toggleEmbedVisibility}, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PostBodyAdditionalContent);
